module.exports = __webpack_public_path__ + "static/media/hardware-banner2.e225c42d.png";